export default "__VITE_ASSET__Deyjw9Ws__"